import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Button,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
}));

type PatternCardParams = {
  id: string | number | undefined;
  title: string;
  imageSrc: string;
  isLink?: boolean;
};

const PatternCard: FC<PatternCardParams> = ({
  id,
  title,
  imageSrc,
  isLink = true,
}) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card className={classes.card}>
        <CardMedia
          className={classes.cardMedia}
          image={imageSrc}
          title="React"
        />
        <CardContent className={classes.cardContent}>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" color="primary">
            {isLink && id && <Link to={`/tools/${id}`}>View</Link>}
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};

export default PatternCard;
